var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsgEmptyDirectory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 133.77,
    y1: -204.59,
    x2: 133.77,
    y2: -302.66,
    gradientTransform: "matrix(1 0 0 -1 0 -91.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ecf0f5"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#eaeef9}.cls-3{fill:#989fb0}.cls-4{fill:#dae2eb}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.58 242.24c61.61 0 111.57-49.59 111.57-110.82S195.19 20.6 133.58 20.6 22.01 70.19 22.01 131.42s49.96 110.82 111.57 110.82Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.04 116.96v67.81c0 14.09-11.46 25.55-25.73 25.55H74.23c-14.09 0-25.54-11.27-25.73-25.36v-68.37c0-.38 0-.75.19-1.13.19-.56.38-.94.56-1.5l31.93-61.04c1.13-2.44 3.57-3.76 6.2-3.76h92.6c2.63 0 4.88 1.31 6.2 3.76l31.93 61.04c.19.38.38.94.56 1.5.38.38.38.94.38 1.5Z",
    style: {
      fill: "#d5ddea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.04 116.96v74.76c0 10.33-8.26 18.6-18.78 18.6H67.28c-10.33 0-18.78-8.26-18.78-18.6v-75.13c0-.38 0-.75.19-1.13h42.82c6.39 0 11.65 5.07 11.65 11.65 0 3.19 1.31 6.2 3.38 8.26 2.25 2.25 4.88 3.38 8.26 3.38h38.13c6.39 0 11.65-5.07 11.65-11.65 0-3.19 1.31-6.2 3.38-8.26 2.25-2.25 4.88-3.38 8.08-3.38h42.64c.38.38.38.94.38 1.5Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.3 78.45c4.25 0 7.7-3.45 7.7-7.7s-3.45-7.7-7.7-7.7-7.7 3.45-7.7 7.7 3.45 7.7 7.7 7.7ZM234.6 53.47a5.26 5.26 0 1 0-5.26-5.26c0 2.91 2.35 5.26 5.26 5.26ZM21.6 70.75c2.9 0 5.26-2.35 5.26-5.26s-2.35-5.26-5.26-5.26-5.26 2.35-5.26 5.26 2.35 5.26 5.26 5.26ZM9.77 186.45c5.39 0 9.77-4.37 9.77-9.77s-4.37-9.77-9.77-9.77S0 171.28 0 176.68s4.37 9.77 9.77 9.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.76 26.55c2.45 26.76 3.68 32.89-1.87 57.12-1.8 5.39-3.61 11.29-7.48 15.39-5.41 6.41-15.21 9.24-23.21 7.18-8.25-2.05-14.95-9.24-16.5-17.96-1.29-5.39.52-11.8 5.16-15.14 4.9-3.08 11.86-2.31 15.99 1.54 4.64 3.85 6.45 9.75 6.19 15.39-.26 5.64-2.32 11.29-5.16 16.16-6.41 11.99-9.05 11.94-22.17 31.63",
    style: {
      fill: "none",
      stroke: "#abb5cc",
      strokeDasharray: "0 0 4 4",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.14 16.59c-.98 3.58-4.9 4.88-8.82 2.6-4.25-1.95-7.19-3.58-6.53-6.83.98-3.25 4.9-3.58 9.47-3.9 5.55-.65 6.53 4.55 5.88 8.13ZM163.45 19.84c1.63 2.93 6.21 4.88 9.47 1.95 3.59-3.25 6.53-5.53 4.9-8.78-1.63-2.93-4.25-1.95-9.8-1.3-4.57.98-6.53 4.88-4.57 8.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.82 7.81c2.29-.33 4.57.98 5.23 2.93.33.65.65 1.63.65 2.28.65 4.55-.98 8.45-3.59 8.78-2.94.65-5.88-2.6-6.21-6.83v-2.93c.33-2.28 1.63-3.9 3.92-4.23.33 0 0 0 0 0ZM112.34 165.72a4.31 4.31 0 1 0 0-8.62 4.31 4.31 0 0 0 0 8.62ZM155.2 165.72a4.31 4.31 0 1 0 0-8.62 4.31 4.31 0 0 0 0 8.62ZM140.76 194.02h-13.51c-2.1 0-3.84-1.75-3.84-3.84s1.75-3.84 3.84-3.84h13.39c2.1 0 3.84 1.75 3.84 3.84.12 2.1-1.63 3.84-3.73 3.84Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgEmptyDirectory);
export default __webpack_public_path__ + "static/media/esg_empty-directory.00398246d351fd40ed4f0b841c2c0df2.svg";
export { ForwardRef as ReactComponent };